import React, { Component } from 'react';
import { Grid, Form, Button, Segment, Icon, } from 'semantic-ui-react';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { postAccountPayment } from '../../utils/rest';
import PaymentTab from './PaymentTab';
import Loading from '../Loading';
import MessageBox from '../../ui/MessageBox';
class EnterPayments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openMsg7: false
        };
    }

    handleSubmit = (paymentInfo) => {
        this.setState({
            loading: true
        }, () => {
            let data = {
                cltClientId: this.props.data[0].cltClientId,
                conConsumerId: this.props.data[0].conConsumerId,
                acoAccountId: this.props.data[0].acoAccountId,
                acoInvoiceId: this.props.data[0].acoInvoiceId,
                conFirstName: this.props.data[0].conFirstName,
                conLastName: this.props.data[0].conLastName,
                paymentAmount: paymentInfo.paymentAmount,
                paymentDate: paymentInfo.paymentDate,
                paymentType: paymentInfo.paymentType,
                adjustmentAmount: paymentInfo.adjustmentAmount,
                adjustmentDate: paymentInfo.adjustmentDate,
                adjustmentType: paymentInfo.adjustmentType
            }
            postAccountPayment(this.props.items.currentCorporate, true, data).then((response) => {
                if (response !== null) {
                    this.setState({
                        loading: false,
                        openMsg7: true
                    });
                }
            }).then(() => {
                this.setState({
                    loading: false
                })
            });
        });
    }

    exit = () => {
        this.setState({
            openMsg7: false
        })
        this.props.showSearchInterface();
    }



    render() {
        if (this.state.loading) {
            return (<Loading />
            )
        }
        const { data } = this.props;
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="Payments" child={[{ name: "Enter Payments & Adjustments", url: "/payment" }, { name: "Entry", url: null }]} />
                <Grid className="back-btn">
                    <Grid.Column>
                        <Button className="left labeled icon small" onClick={this.props.showSearchInterface}>
                            <Icon className="left arrow"></Icon>
                            Back
                         </Button>
                    </Grid.Column>
                </Grid>
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form>
                                <Segment.Group horizontal className="small">
                                    <Segment>
                                        <label className="inline-label-compose">{this.props.t("consumer.name")}: </label>
                                        <span>{this.props._ifNull(data[0].conFirstName, "") + ", " + this.props._ifNull(data[0].conLastName, "")}</span>
                                    </Segment>
                                    <Segment>
                                        <label className="inline-label-compose">SSN: </label>
                                        <span>{this.props._padString(data[0].conSsn)}</span>
                                    </Segment>
                                    <Segment>
                                        <label className="inline-label-compose">Phone: </label>
                                        <span>{this.props._ifNull(data[0].cphPhone, "")}</span>
                                    </Segment>
                                    <Segment>
                                        <label className="inline-label-compose">Employer: </label>
                                        <span>{this.props._ifNull(data[0].coeEmployer, "")}</span>
                                    </Segment>
                                    <Segment>
                                        <label className="inline-label-compose">Co-Guarantor: </label>
                                        <span>{this.props._ifNull(data[0].acmConLastName, "") + " " + this.props._ifNull(data[0].acmConFirstName, "")} {this.props._ifNull(data[0].acmRelationShip, "").length > 0 ? [this.props._ifNull(data[0].acmRelationShip, "")] : ""}</span>
                                    </Segment>
                                </Segment.Group>
                            </Form>
                            <PaymentTab {...this.props} handleSubmit={this.handleSubmit} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox box={7} open={this.state.openMsg7} close={this.close} exit={this.exit} {...this.props} />
            </div>
        );
    }
}
export default EnterPayments;


// WEBPACK FOOTER //
// ./src/app/ui/payments/EnterPayments.js